// extracted by mini-css-extract-plugin
export var icon = "_bv-3";
export var subtitle = "_bv-2";
export var title = "_bv-1";
export var value = "_bv-0";